"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorage = void 0;

var Storage_1 = require("./Storage");

var LocalStorage = /*#__PURE__*/function (_Storage_1$Storage) {
  _inherits(LocalStorage, _Storage_1$Storage);

  function LocalStorage() {
    _classCallCheck(this, LocalStorage);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalStorage).apply(this, arguments));
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      var result = window.localStorage.getItem(key);
      return result === null ? undefined : result;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      window.localStorage.removeItem(key);
    }
  }]);

  return LocalStorage;
}(Storage_1.Storage);

exports.LocalStorage = LocalStorage;